import { Box, Flex, Slider, SliderFilledTrack, SliderMark, SliderThumb, SliderTrack } from '@chakra-ui/react';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { TwoColumn } from '../../containers/TwoColumn/twoColumn';
import { LeftColumn } from '../../containers/TwoColumn/leftColumn';
import { RightColumn } from '../../containers/TwoColumn/rightColumn';
import { FormSectionHeading } from 'src/components/common/texts/FormSectionHeading/formSectionHeading';
import { FormSectionAddon } from 'src/components/common/texts/FormSectionAddon/formSectionAddon';
import { Chart } from './Chart/chart';
import { Color } from 'src/theme/color';
import { ChartLegend } from './ChartLegend/chartLegend';

export const SetMarketplaceFee = () => {
	const { values, setFieldValue } = useFormikContext();
	const { t } = useTranslation();

	return (
		<TwoColumn>
			<LeftColumn>
				<FormSectionHeading label={t('form.steps.setMarketplaceFee.label')}>
					{t('form.steps.setMarketplaceFee.heading')}
				</FormSectionHeading>
				<Flex
					alignItems="center"
					w="100%"
				>
					<Box
						h="11px"
						w="10%"
						bg={Color.GRAY_1}
					></Box>
					<Slider
						w="85%"
						aria-label="slider-ex-1"
						defaultValue={(values as any).marketplaceFee}
						max={85}
						min={0}
						h="11px"
						onChange={val => setFieldValue('marketplaceFee', val)}
					>
						<SliderTrack
							bg={`repeating-linear-gradient(to right, ${Color.GRAY_3} 0px, ${Color.GRAY_3} 2px, transparent 2px, transparent 4px)`}
							h="11px"
						>
							<SliderFilledTrack
								h="11px"
								bg={`repeating-linear-gradient(to right, ${Color.HASHUP} 0px, ${Color.HASHUP} 2px, transparent 2px, transparent 4px)`}
							/>
						</SliderTrack>
						<SliderMark
							value={(values as any).marketplaceFee}
							textAlign="center"
							bg="transparent"
							color="white"
							mt="14px"
							ml="-13px"
							w="30px"
							fontSize="12px"
							fontWeight="bold"
						>
							{(values as any).marketplaceFee}
							<Box
								display="inline"
								color={Color.HASHUP}
							>
								%
							</Box>
						</SliderMark>
						<SliderThumb
							border="none"
							bg="none"
							w="24px"
							borderRadius="6px"
						>
							<Box
								w="24px"
								h="15px"
								bg={Color.HASHUP_2}
								borderRadius="6px"
								border={`2px solid ${Color.HASHUP}`}
							></Box>
						</SliderThumb>
					</Slider>
					<Box
						h="11px"
						w="5%"
						bg={Color.GRAY_3}
					></Box>
				</Flex>
				<Flex>
					<ChartLegend
						price={Number((values as any).price)}
						dataset={[
							{
								value: 10,
								label: 'HashUp',
								color: Color.GRAY_1,
							},
							{
								value: 90 - (values as any).marketplaceFee,
								label: t('creator'),
								color: Color.GRAY_3,
							},
							{
								value: (values as any).marketplaceFee,
								label: t('marketplace'),
								color: Color.HASHUP,
							},
						]}
					/>
				</Flex>

				<FormSectionAddon>
					<Box>{t('form.steps.setMarketplaceFee.desc')}</Box>
				</FormSectionAddon>
			</LeftColumn>
			<RightColumn>
				<Flex
					h="470px"
					//py="60px"
					position="relative"
					alignItems="center"
					justifyContent="center"
				>
					<Chart
						dataset={[
							{
								value: 10,
								label: 'HashUp',
								color: Color.GRAY_1,
							},
							{
								value: 90 - (values as any).marketplaceFee,
								label: t('creator'),
								color: Color.GRAY_3,
							},
							{
								value: (values as any).marketplaceFee,
								label: t('marketplace'),
								color: Color.HASHUP,
							},
						]}
					/>
				</Flex>
			</RightColumn>
		</TwoColumn>
	);
};
